export var Sports;
(function (Sports) {
    Sports["Walking"] = "Walking";
    Sports["Run"] = "Run";
    Sports["Ride"] = "Ride";
    Sports["Swimming"] = "Swimming";
    Sports["Skiing"] = "Skiing";
    Sports["Unknown"] = "Unknown";
})(Sports || (Sports = {}));
